"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _actions = require("./actions");

var _LandingPage = _interopRequireDefault(require("./LandingPage"));

var _constants = require("./constants");

var _handleActions;

var initalState = (0, _immutable.fromJS)({
  byId: (0, _immutable.Map)(),
  byNameQuery: (0, _immutable.Map)(),
  byLanguage: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchLandingPagesByIdsActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['byId'], function (byId) {
    return (0, _mergeWithCollectionOfType.default)(_LandingPage.default, action.payload.data.objects, byId);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchLandingPagesByNameQueryActionTypes.SUCCESS, function (state, action) {
  var searchId = action.payload.props.searchId;
  return state.setIn(['byNameQuery', searchId], (0, _mergeWithCollectionOfType.default)(_LandingPage.default, action.payload.data.objects, (0, _immutable.Map)()));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchLandingPagesByLanguageContentActionTypes.SUCCESS, function (state, action) {
  var domain = action.payload.props.domain;
  return state.setIn(['byLanguage', domain], (0, _mergeWithCollectionOfType.default)(_LandingPage.default, action.payload.data, (0, _immutable.Map)()));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateLandingPageActionTypes.SUCCESS, function (state, action) {
  var page = action.payload.data;
  var domain = page[_constants.LIVE_DOMAIN];
  return state.setIn(['byLanguage', domain, page.id], new _LandingPage.default(page));
}), _handleActions), initalState);

exports.default = _default;
module.exports = exports.default;